import React from 'react';
import PdfViewer from '../marketing/PdfViewer';

const PDF_URL = 'https://global.divhunt.com/7ceadd41ee6075fdb243ab764b777168_337457.pdf';

export default function CWObjectionGuide() {
  return (
    <PdfViewer
      eyebrow="Objection &amp; churn handling"
      title="Win more clients. Keep them longer."
      intro="View the objection handling guide here, open it full screen, or download a copy."
      url={PDF_URL}
      frameTitle="CW objection handling guide"
    />
  );
}